var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Select a status to apply")]),
    _c(
      "div",
      { staticClass: "status-selection" },
      [
        _c(
          "md-field",
          [
            _c("label", [_vm._v("Status")]),
            _c(
              "md-select",
              {
                attrs: { "md-no-validate": "" },
                model: {
                  value: _vm.statusModel,
                  callback: function ($$v) {
                    _vm.statusModel = $$v
                  },
                  expression: "statusModel",
                },
              },
              _vm._l(_vm.statusOptions, function (status) {
                return _c(
                  "md-option",
                  { key: status, attrs: { value: status } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(status) +
                        "\n                "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }